module.exports = __webpack_public_path__ + "static/media/auchan5.65df1a45.jpg";